import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { useIntl } from 'react-intl';
import BuyButton from '@tovia/man-ui/lib/components/Button/Button';

function PurchaseGalleryUser(props) {
  const {
    className,
    purchaseError,
    purchaseLoading,
    purchaseRedirect,
    purchaseScene,
    purchaseStatus,
    submitted,
    validating,
  } = props;

  const intl = useIntl();

  const showBuyButton = (!purchaseStatus && !purchaseError && !purchaseRedirect) || validating;
  const showErrorMsg = !!(submitted && purchaseError);
  const showRedirectMsg = submitted && purchaseRedirect;
  const showSuccessMsg = submitted && !purchaseError && purchaseStatus && !purchaseRedirect && !validating;

  return (
    <div className={className}>
      {showBuyButton && (
        <div>
          <BuyButton
            className="submit-button btn btn-primary"
            loading={purchaseLoading || validating}
            onClick={purchaseScene}
            spinnerClass="buy-spinner"
          >
            {intl.formatMessage({ id: 'purchaseGallery.user.button', defaultMessage: 'Buy Now' })}
          </BuyButton>
        </div>
      )}
      {showErrorMsg && (
        <p className="purchase-text">
          {intl.formatMessage({
            id: 'purchaseGallery.user.errorMessage',
            defaultMessage: 'Unable to purchase content. Please contact support.',
          })}
        </p>
      )}
      {showSuccessMsg && (
        <>
          <p className="purchase-text">
            {intl.formatMessage({
              id: 'purchaseGallery.user.successMessage',
              defaultMessage: 'Success! Thank you for purchasing!',
            })}
          </p>
          <p className="please-wait-text">
            {intl.formatMessage({
              id: 'purchaseGallery.user.successPleaseWait',
              defaultMessage: 'Please wait while we load your purchase...',
            })}
          </p>
        </>
      )}
      {showRedirectMsg && <p className="purchase-text">Redirecting to complete your purchase...</p>}
    </div>
  );
}

PurchaseGalleryUser.propTypes = {
  cartItem: PropTypes.shape({
    cartItemUUID: PropTypes.string,
    product: PropTypes.object,
    status: PropTypes.number,
    iframeURL: PropTypes.string,
    redirectURL: PropTypes.string,
  }),
  className: PropTypes.string,
  purchaseError: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  purchaseLoading: PropTypes.bool,
  purchaseRedirect: PropTypes.string,
  purchaseScene: PropTypes.func.isRequired,
  purchaseStatus: PropTypes.bool,
  submitted: PropTypes.bool.isRequired,
  validating: PropTypes.bool,
};

PurchaseGalleryUser.defaultProps = {
  cartItem: null,
  className: '',
  purchaseError: null,
  purchaseRedirect: null,
};

export default styled(PurchaseGalleryUser)`
  & .cancel-button,
  & .submit-button {
    position: relative;
    border: 0 none;
    display: inline-block;
    flex-grow: 1;
    font-size: 1.3rem;
    height: 48px;
    margin: 16px 0;
    text-align: center;
    text-transform: uppercase;
    width: 100%;

    &.loading {
      background-color: #9d9d9d;
      color: transparent !important;
    }

    .buy-spinner {
      display: block;
      height: 0;
      position: relative;
      width: 100%;

      .spinner {
        width: 28px;
        height: 28px;

        path {
          fill: #888888;
        }
      }
    }
  }

  & .purchase-buttons {
    display: flex;
    justify-content: center;
  }

  & .purchase-text {
    font-size: 1.15rem;
    font-weight: 600;
    margin-top: 16px;
    text-align: center;

    a {
      text-decoration: underline;
    }
  }

  & .please-wait-text {
    font-size: 0.95rem;
    text-align: center;
  }

  & .loader {
    margin: 64px 0;
  }
`;
